<template>
    <v-row justify="center">
        <v-dialog
            v-model="dialog"
            :persistent='true'
            width="52%"
            height="100%"
            class="modalDialog"
            no-click-animation
          >
            <div class="memberAdd">
                <v-card class="cardWrap">
                    <CardTitle :title="page_title" />
                    <v-card-actions class="cardWrap__scroll">
                      <v-container>
                      <v-form
                        class="cardWrap__fromArea"
                        ref="form"
                        :lazy-validation="lazy"
                        v-model="valid"
                      >
                        <v-row justify="space-around" class="formWidth formHeight">
                          <div class="cardWrap__fromArea__title">ゴルフコード</div>
                            <v-text-field
                              :disabled="changeModeStatus"
                              v-model="from_set_data.golf_code"
                              maxlength="10"
                              :rules="[rules.required, rules.format_golf_code]"
                              autofocus
                            />
                        </v-row>
                        <v-row justify="space-around" class="formHeight">
                          <div class="cardWrap__fromArea__title">ゴルフ場名</div>
                            <v-text-field
                              v-model="from_set_data.golf_name"
                              maxlength="50"
                              :rules="[rules.required]"
                            />
                        </v-row>
                        <v-row justify="space-around" class="formHeight">
                          <div class="cardWrap__fromArea__title">カナ</div>
                            <v-text-field
                            v-model="from_set_data.golu_kana"
                            maxlength="50"
                            :rules="[rules.required, rules.format_kana]"
                            />
                        </v-row>
                        <v-row justify="space-around" class="formWidth formHeight">
                          <div class="cardWrap__fromArea__title">郵便番号</div>
                            <v-text-field
                            v-model.lazy="from_set_data.zip_code"
                            maxlength="7"
                            :rules="[rules.required, rules.format_zipcode]"
                            />
                        </v-row>
                        <v-row justify="space-around" class="formHeight">
                          <div class="cardWrap__fromArea__title">都道府県</div>
                            <v-select
                              :items="prefectureData"
                              v-model="from_set_data.prefecture_name"
                              />
                        </v-row>
                        <v-row justify="space-around" class="formHeight">
                          <div class="cardWrap__fromArea__title">市町村区</div>
                            <v-text-field
                            v-model="from_set_data.municipality_name"
                            maxlength="256"
                            :rules="[rules.required]"
                            />
                        </v-row>
                        <v-row justify="space-around" class="formHeight">
                          <div class="cardWrap__fromArea__title">番地</div>
                            <v-text-field
                            v-model="from_set_data.local_name"
                            maxlength="256"
                            />
                        </v-row>
                        <v-row justify="space-around" class="formHeight">
                          <div class="cardWrap__fromArea__title">建物名</div>
                            <v-text-field
                            v-model="from_set_data.building_name"
                            maxlength="256"
                            />
                        </v-row>
                        <v-row justify="space-around" class="formHeight formWidth">
                          <div class="cardWrap__fromArea__title">電話番号</div>
                            <v-text-field
                              v-model.lazy="from_set_data.telephone"
                              type="tel"
                              maxlength="15"
                              :rules="[rules.required, rules.format_tel, rules.min_length_tel]"
                            />
                        </v-row>
                        <v-row justify="space-around" class="formHeight formWidth">
                        <div class="cardWrap__fromArea__title">fax</div>
                            <v-text-field
                              v-model.trim="from_set_data.fax"
                              type="tel"
                              maxlength="15"
                              :rules="[rules.format_tel]"
                            />
                        </v-row>
                        <v-row justify="space-around" class="formHeight">
                        <div class="cardWrap__fromArea__title">画像</div>
                            <v-text-field
                              readonly
                              v-model="displayfilename"
                            />
                            <input
                              style="display: none"
                              accept=".jpg,.png,.image"
                              type="file"
                              ref="input"
                              v-on:change="fileSelected"
                            />
                            <v-btn color="primary" @click="btnclick">画像選択</v-btn>
                        </v-row>
                        <!-- <v-row justify="space-around" class="formHeight">
                        <div class="cardWrap__fromArea__title">同伴者の締切</div>
                            <v-text-field
                              v-model.trim="from_set_data.play_together_fixed_deadline"
                              type="tel"
                              maxlength="3"
                              :rules="[rules.required, rules.digit]"
                            />
                            <div class="cardWrap__fromArea__end">日前</div>
                        </v-row> -->
                        <v-row justify="start">
                          <div class="cardWrap__fromArea__title">基幹との枠連携</div>
                            <v-radio-group
                                class="px-3"
                                v-model="from_set_data.cell_link_type"
                                row>
                                <v-radio label="有" value="1" />
                                <v-radio label="無" value="0" />
                            </v-radio-group>
                        </v-row>
                        <v-row justify="start">
                          <div class="cardWrap__fromArea__title">ポイント利用タイプ</div>
                            <v-radio-group
                                class="px-3"
                                v-model="from_set_data.point_grant_type"
                                row>
                                <v-radio label="利用する" value="1" />
                                <v-radio label="利用しない" value="0" />
                            </v-radio-group>
                        </v-row>
                        <v-row justify="start" v-if="display_course_flag">
                          <div class="cardWrap__fromArea__title text-center">コース名初期表示 (同伴者画面)</div>
                            <v-radio-group
                                class="px-3"
                                v-model="from_set_data.display_course"
                                row>
                                <v-radio label="有" value="1" />
                                <v-radio label="無" value="0" />
                            </v-radio-group>
                        </v-row>
                        <v-row justify="space-around" class="formHeight">
                          <div class="cardWrap__fromArea__title">印字会社名</div>
                            <v-text-field
                            v-model="from_set_data.company_name"
                            maxlength="50"
                            />
                        </v-row>
                        <v-row justify="start" v-if="changeModeStatus">
                          <div class="cardWrap__fromArea__title">有効フラグ</div>
                          <v-checkbox v-model="from_set_data.valid_flag" class="mx-2" label="有効フラグ" />
                        </v-row>
                      </v-form>
                      </v-container>
                    </v-card-actions>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
                      <v-btn color="green darken-4" text v-if="addModeStatus" @click="validateCheck">登録</v-btn>
                      <v-btn color="green darken-4" text v-if="changeModeStatus" @click="changeOverlay = !changeOverlay">変更</v-btn>
                    </v-card-actions>
                </v-card>
            </div>
            <AddOverlay
              page-name="ゴルフ場"
              @processing="registerGolfCourse"
              @cancel="addOverlay = !addOverlay"
              :process-result="process"
              :overlay-switch="addOverlay"
            />
            <ChangeOverlay
              page-name="ゴルフ場"
              @processing="updateGolfCourse"
              @cancel="changeOverlay = !changeOverlay"
              :process-result="process"
              :OverlaySwitch="changeOverlay"
            />
        </v-dialog>
    </v-row>
</template>

<script>
import CardTitle from '../../../../components/module/CardTitle';
import {
    REGISTER_GOLFCOURSE,
    UPDATE_GOLFCOURSE } from '../../../../constants/master';
import AddOverlay from '../overlay/AddOverlay';
import axios from 'axios';
import ChangeOverlay from '../overlay/ChangeOverlay';
import validater from '../../../../lib/validater';
import { InputPagesMixin } from './../mixin/InputPagesMixin';

export default {
    components: {
        CardTitle,
        AddOverlay,
        ChangeOverlay
    },
    // マスタ管理で共通項目をMixinする ./mixin/InputPagesMixin.js
    mixins: [InputPagesMixin],
    props: ['editInfo'],
    data () {
        return {
            page_title: 'ゴルフ場登録',
            image: null,
            displayfilename: '',
            // 入力値
            from_set_data: {
                // ゴルフ場コード
                golf_code: '',
                // ゴルフ場名
                golf_name: '',
                // カナ
                golu_kana: '',
                // 郵便番号
                zip_code: '',
                // 都道府県
                prefecture_name: '',
                // 市町村区
                municipality_name: '',
                // 番地
                local_name: '',
                // ビル名
                building_name: '',
                // 電話番号
                telephone: '',
                // fax
                fax: null,
                // ヘッダー画像
                golf_course_img_path: '',
                // // 同伴者の締切
                // play_together_fixed_deadline: '0',
                // ポイント機能利用タイプ
                point_grant_type: 0,
                // 基幹枠連携利用タイプ
                cell_link_type: 0,
                // コース名初期表示タイプ
                display_course: 0,
                // 印字会社名
                company_name: '',
                // 有効フラグ
                valid_flag: ''
            },
            // クラシックでコース名表示設定を表示するフラグ
            display_course_flag: process.env.VUE_APP_NAME === 'hcgc',
            fileInfo: '',
            prefectureData: [
                '北海道', '青森県', '岩手県', '宮城県', '秋田県',
                '山形県', '福島県', '茨城県', '栃木県', '群馬県',
                '埼玉県', '東京都', '千葉県',
                '神奈川県', '新潟県', '長野県', '山梨県', '富山県',
                '石川県', '福井県', '岐阜県', '静岡県', '愛知県',
                '滋賀県', '京都府', '大阪府', '奈良県', '兵庫県',
                '和歌山県', '三重県', '鳥取県', '島根県', '岡山県',
                '広島県', '山口県', '徳島県', '香川県', '愛媛県',
                '高知県', '福岡県', '佐賀県', '長崎県', '熊本県',
                '大分県', '宮崎県', '鹿児島県', '沖縄県'
            ],
            // バリデーション
            lazy: true,
            rules: {
                required: value => !!value || this.$t('error.validation.required.any'),
                // ゴルフ場コードバリデーション
                format_golf_code: value => !!validater.checkStringType(value) || this.$t('error.validation.stringtype'),
                // カナバリデーション
                format_kana: value => !!validater.checkKana(value) || this.$t('error.validation.kanaFormat'),
                // 郵便番号バリデーション
                format_zipcode: value => !!validater.checkZipCode(value) || this.$t('error.validation.zipCodeFormat'),
                min_length_tel: value => value.length >= 10 || this.$t('error.validation.length.tel'),
                // 電話番号バリデーション
                format_tel: value => !!validater.checkTel(value) || this.$t('error.validation.telFormat'),
                digit: value => !!validater.checkIntType(value) || this.$t('error.validation.num')
            }
        };
    },
    created () {
        this.Initialize();
    },
    computed: {
        addModeStatus () {
            return this.modeStatus === 'addMode';
        },
        changeModeStatus () {
            return this.modeStatus === 'changeMode';
        }
    },
    watch: {
        addOverlay () {
            if (this.addOverlay === false) {
                this.process.result = '';
            }
        },
        // modeStatusで表示を切り替える
        modeStatus () {
            if (this.modeStatus === 'addMode') {
                this.page_title = 'ゴルフ場登録';
            } else if (this.modeStatus === 'changeMode') {
                this.page_title = 'ゴルフ場変更';
            }
        },
        // 親コンポーネント(GolfCourse.vue)から渡された値をinputに代入
        editInfo () {
            this.from_set_data.golf_code = this.editInfo.golf_code;
            this.from_set_data.golf_name = this.editInfo.golf_name;
            this.from_set_data.golu_kana = this.editInfo.golu_kana;
            this.from_set_data.zip_code = this.editInfo.zip_code;
            this.from_set_data.prefecture_name = this.editInfo.prefecture_name;
            this.from_set_data.municipality_name = this.editInfo.municipality_name;
            this.from_set_data.local_name = this.editInfo.local_name;
            this.from_set_data.building_name = this.editInfo.building_name;
            this.from_set_data.telephone = this.editInfo.telephone;
            this.from_set_data.golf_course_img_path = this.editInfo.golf_course_img_path;
            this.from_set_data.fax = this.editInfo.fax;
            this.from_set_data.valid_flag = this.editInfo.valid_flag;
            this.from_set_data.play_together_fixed_deadline = this.editInfo.play_together_fixed_deadline;
            if (this.editInfo.golf_course_img_path) {
                this.displayfilename = this.editInfo.golf_course_img_path.replace('/images/storage/', '');
            }
            this.from_set_data.point_grant_type = String(this.editInfo.point_grant_type);
            this.from_set_data.cell_link_type = String(this.editInfo.cell_link_type);
            this.from_set_data.display_course = String(this.editInfo.display_course);
            this.from_set_data.company_name = this.editInfo.company_name;
        }
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.addOverlay = false;
            this.changeOverlay = false;
            this.from_set_data = {
                golf_code: '',
                golf_name: '',
                golu_kana: '',
                zip_code: '',
                prefecture_name: '',
                municipality_name: '',
                local_name: '',
                building_name: '',
                telephone: '',
                fax: null,
                golf_course_img_path: null,
                point_grant_type: 0,
                cell_link_type: 0,
                display_course: 1,
                company_name: '',
                valid_flag: ''
            };
            this.process = {
                result: '',
                resultText: ''
            };
        },
        btnclick () {
            this.$refs.input.click();
        },
        /** ----------------------------------------------
         * 画像選択時に常に画像を取得
         * ---------------------------------------------- */
        fileSelected (event) {
            this.fileInfo = event.target.files[0];
            this.isUploading = true;
            const files = this.$refs.input.files[0];
            if (!files) {
                return;
            }
            this.displayfilename = files.name;
        },
        /** ----------------------------------------------
         * 画像アップロード
         * ---------------------------------------------- */
        FileUpload: async function () {
            const formData = new FormData();
            formData.append('file', this.fileInfo);
            await axios.post('/api/fileupload', formData
            ).then(response => {
                this.from_set_data.golf_course_img_path = '/images/storage/' + response.data;
            });
        },
        registerGolfCourse: async function () {
            // 二重送信防止処理
            if (this.process.processing) return;
            this.process.processing = true;
            if (this.fileInfo) {
                await this.FileUpload();
            }
            // API送信
            this.$apollo.mutate({
                mutation: REGISTER_GOLFCOURSE,
                variables: {
                    golf_code: this.from_set_data.golf_code,
                    golf_group_code: process.env.VUE_APP_GROUP_CODE,
                    golf_name: this.from_set_data.golf_name,
                    golu_kana: this.from_set_data.golu_kana,
                    zip_code: this.from_set_data.zip_code,
                    prefecture_name: this.from_set_data.prefecture_name,
                    municipality_name: this.from_set_data.municipality_name,
                    local_name: this.from_set_data.local_name,
                    building_name: this.from_set_data.building_name,
                    telephone: this.from_set_data.telephone,
                    fax: this.from_set_data.fax,
                    golf_course_img_path: this.from_set_data.golf_course_img_path,
                    point_grant_type: this.from_set_data.point_grant_type,
                    // play_together_fixed_deadline: this.from_set_data.play_together_fixed_deadline
                    cell_link_type: this.from_set_data.cell_link_type,
                    display_course: this.from_set_data.display_course,
                    company_name: this.from_set_data.company_name
                }
            }).then(res => {
                this.process.result = res.data.registerGolfCourse.result;
                if (this.process.result === 1) {
                    this.CloseModal();
                } else if (this.process.result === 2) {
                    this.process.resultText = this.$t('result.error.existsGolfCode');
                }
                this.process.processing = false;
            }).catch(error => {
                this.error = error;
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.add');
                this.process.result = '';
                this.process.processing = false;
            });
        },
        updateGolfCourse: async function () {
            // 二重送信防止処理
            if (this.process.processing) return;
            this.process.processing = true;
            if (this.fileInfo) {
                await this.FileUpload();
            }

            // システム管理者のvalid_flagは9にする
            if (this.from_set_data.valid_flag === 0) {
                this.validFlag = 0;
            } else {
                this.validFlag = this.from_set_data.valid_flag;
            }
            this.$apollo.mutate({
                mutation: UPDATE_GOLFCOURSE,
                variables: {
                    golf_code: this.from_set_data.golf_code,
                    golf_name: this.from_set_data.golf_name,
                    golu_kana: this.from_set_data.golu_kana,
                    zip_code: this.from_set_data.zip_code,
                    prefecture_name: this.from_set_data.prefecture_name,
                    municipality_name: this.from_set_data.municipality_name,
                    local_name: this.from_set_data.local_name,
                    building_name: this.from_set_data.building_name,
                    telephone: this.from_set_data.telephone,
                    fax: this.from_set_data.fax,
                    valid_flag: this.from_set_data.valid_flag,
                    golf_course_img_path: this.from_set_data.golf_course_img_path,
                    point_grant_type: this.from_set_data.point_grant_type,
                    // play_together_fixed_deadline: this.from_set_data.play_together_fixed_deadline
                    cell_link_type: this.from_set_data.cell_link_type,
                    display_course: this.from_set_data.display_course,
                    company_name: this.from_set_data.company_name
                }
            }).then(res => {
                this.process.result = res.data.updateGolfCourse.result;
                this.process.processing = false;
                this.fileInfo = null;
                this.CloseModal();
            }).catch(error => {
                this.error = error;
                this.process.result = 0;
                this.process.resultText = this.$t('result.error.change');
                this.process.result = '';
                this.process.processing = false;
            });
        },
        validateCheck () {
            if (this.$refs.form.validate()) {
                if (this.modeStatus === 'addMode') {
                    this.addOverlay = true;
                } else if (this.modeStatus === 'changeMode') {
                    this.changeOverlay = true;
                }
            }
        },
        /** ----------------------------------------------
         * 親画面にて「追加」ボタン押下時の処理
         * ---------------------------------------------- */
        addModal () {
            this.Initialize();
            this.dialog = true;
            this.modeStatus = 'addMode';
        },
        /** --------------------------------------------
        * モーダル画面を表示 './modal/GolfCourseModal.vue'
        * -------------------------------------------- */
        editModal () {
            this.Initialize();
            this.dialog = true;
            this.modeStatus = 'changeMode';
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.Initialize();
            this.image = null;
            this.displayfilename = null;
            this.$refs.form.resetValidation();
            this.$emit('refresh-event');
            this.dialog = false;
        }
    }
};
</script>

<style scoped>

.formHeight{
  max-height: 60px;
  max-width: 80%;
}

.formWidth{
  max-width: 60%;
}
.cardWrap__fromArea__end{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 50px;
}
</style>
